import NodeStatisticsSection from './NodeStatisticsSection'

function NodeStatisticsTab({ teamSlug, nodeId, active }) {
  if (!active) {
    return null
  }

  return <NodeStatisticsSection teamSlug={teamSlug} nodeId={nodeId} />
}

export default NodeStatisticsTab
